const __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof dealer_sphere !== "undefined") return resolve();
	__webpack_require__.l("/assets/dealer-sphere/remote.js", (event) => {
		if(typeof dealer_sphere !== "undefined") return resolve();
		const errorType = event && (event.type === 'load' ? 'missing' : event.type);
		const realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		__webpack_error__.event = event;
		reject(__webpack_error__);
	}, "dealer_sphere");
}).then(() => (dealer_sphere));